import React from 'react';
import './TeamEmpowerment.css';

const TeamEmpowerment = () => {
  const roles = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
        </svg>
      ),
      title: "For Testers",
      description: "Spend time on real issues, not test definitions. AI creates tests through conversation so you can focus on strategy and quality."
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
        </svg>
      ),
      title: "For Developers",
      description: "Bugs arrive with clear steps to reproduce. Standard Playwright output integrates seamlessly with your CI/CD pipeline."
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      title: "For Everyone",
      description: "Business analysts, product managers, QA leads - anyone can contribute to testing. One language, one platform, one team."
    }
  ];

  return (
    <section className="team-empowerment">
      <div className="team-empowerment-container">
        <div className="team-empowerment-header">
          <h2>Built for Your Entire Team</h2>
          <p>Testing should bring teams together, not create silos</p>
        </div>

        <div className="roles-grid">
          {roles.map((role, index) => (
            <div key={index} className="role-card">
              <div className="role-icon">{role.icon}</div>
              <h3>{role.title}</h3>
              <p>{role.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamEmpowerment;
